module.exports = __webpack_public_path__ + "static/media/18.1eb3d6b7.jpg";